import React, { useState } from "react";
import tw, { styled } from "twin.macro";
import Chart from "react-apexcharts";
import { Loading } from "..";

const Wrapper = styled.div`
	${tw`rounded-2xl w-full xl:w-9/12`}
	padding: 15px;
	width: auto;
	background: #e0e0e0;
	min-width: 240px;
	box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
		0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
`;

const ChartView = (props) => {
	// eslint-disable-next-line
	const [series, setSeries] = useState({
		data: [
			{
				name: "Net Profit",
				data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
			},
		],
	});

	// eslint-disable-next-line
	const [options, setOptions] = useState({
		chart: {
			id: "message-data",
			foreColor: "#040625",
		},
		xaxis: {
			categories: [
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
			],
		},
		yaxis: {
			tickAmount: 4,
			min: 0,
			max: function (max) {
				return max;
			},

			labels: {
				formatter: (value) => {
					return value.toFixed(0);
				},
			},
		},
		subtitle: {
			// text: "Messages Sent",
			align: "left",
			margin: 10,
			offsetX: 0,
			offsetY: 0,
			floating: false,
			style: {
				fontSize: "12px",
				fontWeight: "normal",
				fontFamily: "Roboto",
				color: "#9699a2",
			},
		},
		dataLabels: {
			enabled: false,
		},
		colors: ["#3f51b5"],
		fill: {
			gradient: {
				enabled: true,
				opacityFrom: 0.95,
				opacityTo: 0.2,
			},
		},
		grid: {
			borderColor: "#555",
			clipMarkers: false,
			yaxis: {
				lines: {
					show: false,
				},
			},
		},
	});

	// useEffect(() => {
	// 	setSeries({ ...series, data: data?.series });
	// 	setOptions({ ...options, xaxis: { categories: data?.category } });
	// 	// eslint-disable-next-line
	// }, [data]);

	return (
		<Wrapper>
			{props.loading ? (
				<div className="d-flex align-items-center justify-content-center text-primary">
					<Loading /> <b>Loading Data...</b>
				</div>
			) : (
				<div tw="w-full!">
					<div tw="flex flex-row flex-nowrap items-center justify-between"></div>
					<Chart
						options={options}
						series={series.data}
						type="bar"
						width="100%"
						height={250}
					/>
				</div>
			)}
		</Wrapper>
	);
};

export default ChartView;
